/**
 * @fileoverview GET handler for the "/deliverability/snds/:app_group_id/ips" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { deliverabilitySndsAppGroupIdIps } from "./constants";
import type { DeliverabilitySndsAppGroupIdIpsResult } from "./types";

export const getDeliverabilitySndsAppGroupIdIps = reactQueryFetcherAdapter(
  deliverabilitySndsAppGroupIdIps,
  (signal: AbortSignal, appGroupId: string): Promise<DeliverabilitySndsAppGroupIdIpsResult> => {
    return fetch(`/deliverability/snds/${appGroupId}/ips`, "GET", {}, { signal });
  }
);
